(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")); /*!
                                                                                                                                                                                                                                                                                              * 跟随主耶稣的脚踪 videos page 模板 页面处理
                                                                                                                                                                                                                                                                                              |
                                                                                                                                                                                                                                                                                              | 全能神说: "在這最末了的時代最末了的時代,
                                                                                                                                                                                                                                                                                              |           讓神的名能在外邦中被稱為大,
                                                                                                                                                                                                                                                                                              |           使神的作為被外邦中的人被外邦中的人看見,
                                                                                                                                                                                                                                                                                              |           且因神的神的作為而稱神為全能者,
                                                                                                                                                                                                                                                                                              |           讓神口之言早日得著早日得著成就"
                                                                                                                                                                                                                                                                                              |
                                                                                                                                                                                                                                                                                              | Almighty God says:
                                                                                                                                                                                                                                                                                              |           “In the end times, in the final age,
                                                                                                                                                                                                                                                                                              |           God’s name will be magnified among Gentile nations.
                                                                                                                                                                                                                                                                                              |           The acts of God will be by Gentiles seen,
                                                                                                                                                                                                                                                                                              |           and they’ll address Him as the Almighty,
                                                                                                                                                                                                                                                                                              |           and thus His words shall one day soon come true”
                                                                                                                                                                                                                                                                                              |
                                                                                                                                                                                                                                                                                              * @author : Buff
                                                                                                                                                                                                                                                                                              * @date : 12/1/2017
                                                                                                                                                                                                                                                                                              * @Time: 11:33 AM
                                                                                                                                                                                                                                                                                              * @standards : ECMAScript 5
                                                                                                                                                                                                                                                                                              */var

v2VideosPage = /*#__PURE__*/function () {
  function v2VideosPage() {(0, _classCallCheck2["default"])(this, v2VideosPage);
    this.$slickConfig = {
      slidesToShow: 4,
      infinite: true,
      adaptiveHeight: true,
      dots: false,
      speed: 450,
      slidesToScroll: 4,
      prevArrow: "<button class=\"prev\"><i class=\"icon-keyboardLeft\"></i></button>",
      nextArrow: "<button class=\"next\"><i class=\"icon-keyboardRight\"></i></button>",
      cssEase: "ease-in-out",
      lazyLoad: "progressive" };


    //  处理视频盒子
    $(".videoListsPlayer").length > 0 && this.videoBoxHandler();

    //  处理平常的列表 轮播器
    $(".slideItem").length > 0 && this.slideItemHandler();

    //  处理large 盒子
    $("#youtubeLarge").length > 0 && this.slideItemLargeHandler();
  }

  //  处理平常的列表 5 个版本
  (0, _createClass2["default"])(v2VideosPage, [{ key: "slideItemLargeHandler", value: function slideItemLargeHandler() {var _this = this;
      //  兼容是否有播放器
      //#############
      if ($(".videoListsPlayer").length > 0) {
        $(window).on("v2YouTubeIframeAPIReady", this.SlideItemLargeVideo);
      } else {
        //  加载youtubeAPI
        $.holdReady(true);
        $.getScript("https://www.youtube.com/iframe_api", function () {
          $.holdReady(false);
        });

        //  初始化视频接口
        window.onYouTubeIframeAPIReady = function () {
          _this.SlideItemLargeVideo;
        };
      }
    }

    //  处理单个视频播放
  }, { key: "SlideItemLargeVideo", value: function SlideItemLargeVideo() {
      var iWidth = $("#youtubeLarge").
      parent().
      width();
      var iHeight = iWidth * 0.5625;
      var largeYtb = new YT.Player("youtubeLarge", {
        height: iHeight,
        width: iWidth,
        playerVars: {
          autoplay: 0,
          html5: 1,
          rel: 0,
          showinfo: 0 },

        suggestedQuality: "hd1080",
        videoId: $("#youtubeLarge").data("vid"),
        events: {
          onReady: function onReady() {
            $(".videoWrapper .loader").remove();
          },
          onStateChange: function onStateChange(event) {} } });



      $(window).resize(function () {
        var iWidth = $("#youtubeLarge").
        parent().
        width();
        var iHeight = iWidth * 0.5625;
        largeYtb && largeYtb.setSize(iWidth, iHeight);
      });
    }

    //  处理平常的列表 轮播器
  }, { key: "slideItemHandler", value: function slideItemHandler() {var _this2 = this;
      $(".slideItem").map(function (index, value) {
        var Carousel = $(value).find(".carousel-slideItem");

        //  在调用之前先复制移动端的item
        $(value).
        find(".carousel-slideItem").
        children().
        map(function (i, item) {
          var clone = $(item).
          clone().
          removeClass("col-3");
          $(value).
          find(".mobileSlide").
          append(clone);
        });

        Carousel.slick(
        $.extend(_this2.$slickConfig, {
          appendArrows: $(value).find(".controlArrows") }));



        $(window).resize(function () {
          Carousel.slick("unslick");

          if (Carousel.children(".item").length > 0) {
            Carousel.slick(
            $.extend(_this2.$slickConfig, {
              appendArrows: $(value).find(".controlArrows") }));


          }
        });
      });
    }

    //  处理视频盒子
  }, { key: "videoBoxHandler", value: function videoBoxHandler() {var _this3 = this;
      this.$youtube = $("#ytb");
      this.$ytbObj = null;
      this.$wrapper = $("#vb .videoWrapper");
      var that = this;

      $(".nano").nanoScroller();

      //  加载youtubeAPI
      $.holdReady(true);
      $.getScript("https://www.youtube.com/iframe_api", function () {
        $.holdReady(false);
      });

      //  初始化视频接口
      window.onYouTubeIframeAPIReady = function () {
        $(window).trigger("v2YouTubeIframeAPIReady");
        //  初始化视频
        var iWidth = _this3.$youtube.width();
        var iHeight = iWidth * 0.5625;
        _this3.$ytbObj = new YT.Player("ytb", {
          height: iHeight,
          width: iWidth,
          playerVars: {
            autoplay: 0,
            html5: 1,
            rel: 0,
            showinfo: 0 },

          suggestedQuality: "hd1080",
          videoId: $("#vb .lists .nano-content").
          children().
          eq(0).
          data("vid"),
          events: {
            onReady: function onReady() {
              $(".videoWrapper .loader").remove();
            },
            onStateChange: function onStateChange(event) {} } });


      };

      //  处理视频拖拽尺寸问题
      $(window).
      resize(function () {
        var iWidth = that.$wrapper.width();
        var iHeight = iWidth * 0.5625;
        that.$ytbObj && that.$ytbObj.setSize(iWidth, iHeight);
      }).
      trigger("resize");

      $("#vb .lists .nano-content").
      children().
      click(function () {
        var item = $(this);
        !item.hasClass("active") &&
        that.$ytbObj &&
        item.
        addClass("active").
        siblings().
        removeClass("active") &&
        that.$ytbObj.loadVideoById(item.data("vid"));
      });
    } }]);return v2VideosPage;}();


new v2VideosPage();

},{"@babel/runtime/helpers/classCallCheck":2,"@babel/runtime/helpers/createClass":3,"@babel/runtime/helpers/interopRequireDefault":4}],2:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
},{}],3:[function(require,module,exports){
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
},{}],4:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
},{}]},{},[1])

//# sourceMappingURL=videosPage.js.map
